module.exports = __webpack_public_path__ + "static/media/07_plantilla_rec_combo_simple_cf_stills_pet_2.25_kin.3d2ed389.png";